<template>
  <div class="connection-inform" v-if="isShowConnectionInform">
    <div class="connection-inform__body">
      <div class="connection-inform__message">
        <aha-spinner variant="white" />
        {{ message }}
      </div>
      <div class="connection-inform__action">
        <button class="connection-inform__reload outline-button" @click="reloadPage">
          {{ $t('Reload') }}
        </button>
        <span class="connection-inform__line"></span>
        <button class="connection-inform_close outline-icon" @click="close">
          <aha-icon
            name="close"
            height="20"
            width="20"
            viewBox="-2 -1 28 28"
          />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { CONNECTION_STATUS } from '@/utils/system/SystemConnection'

export default {
  data() {
    return {
      // reconnectingIcon,
    }
  },
  computed: {
    ...mapGetters('systemConnection', ['showConnectionInform', 'connectionStatus', 'userConnectionStatus']),
    ...mapGetters('featureToggles', ['showConnectionStatus']),
    ...mapGetters(['isPresenting']),
    message() {
      if (this.userConnectionStatus === CONNECTION_STATUS.ERROR) {
        return this.$t('No internet. Retrying...')
      }
      return ''
    },
    isShowConnectionInform() {
      return this.isPresenting && this.showConnectionStatus && this.showConnectionInform &&
        (this.connectionStatus === CONNECTION_STATUS.RECONNECTING)
    },
  },
  methods: {
    ...mapActions('systemConnection', ['setShowConnectionInform']),
    reloadPage() {
      window.location.reload()
    },
    close() {
      this.setShowConnectionInform(false)
    },
  },
};
</script>

<style lang="scss" scoped>
.connection-inform {
  @apply absolute w-full flex z-10;
  color: #fff;
  font-size: 14px;
  top: 90px;
}

.connection-inform__body {
  @apply flex justify-between bg-secondary-100 px-3 py-1 rounded-lg border border-secondary-50;
  min-width: 300px;
  margin: auto;
  gap: 28px;
}
.connection-inform__action {
  @apply flex justify-between items-center;
  gap: 12px;
}

.connection-inform__message {
  display: flex;
  align-items: center;
  gap: 8px;
}

.connection-inform__reload {
  @apply font-bold;
  padding: 10px 6px;

  &:hover {
    @apply text-primary-90;
  }
  &:active {
    @apply text-primary-110;
  }
}

.connection-inform__line {
  @apply bg-secondary-50;
  width: 2px;
  height: 20px;
}

.connection-inform_close {
  @apply cursor-pointer;

  svg {
    &:hover {
      @apply text-primary-90;
    }
    &:active {
      @apply text-primary-110;
    }
  }
}
.outline-icon {
  @apply rounded-full cursor-pointer;
  background-color: transparent;

  &:focus {
    outline: unset;
  }
  &:focus-visible {
    outline: 2px solid #89BEFA;
  }
}
.outline-button {
  @apply rounded-lg cursor-pointer;

  &:focus {
    outline: unset;
  }
  &:focus-visible {
    outline: 2px solid #89BEFA;
  }
}
</style>
